import { render, staticRenderFns } from "./ClientAvatar.vue?vue&type=template&id=020240a4&scoped=true&"
import script from "./ClientAvatar.vue?vue&type=script&lang=js&"
export * from "./ClientAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ClientAvatar.vue?vue&type=style&index=0&id=020240a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020240a4",
  null
  
)

export default component.exports